// "use strict";

angular.module('app.resource', []).// app.factories.devices-module

// -------------------------------------------//
//             API Factory
// -------------------------------------------//
factory('API', ['$resource', 'appConfig',
    function ($resource, appConfig) {
        // TODO: appConfing not as function in API
        var api_host = appConfig().api_host;
        var destinationId = appConfig().destinationId;
        var obj = {};
        var Controllers = {};
        var Menu = {};
        Controllers.Menu = Menu;
        var Datapoint = {};
        Controllers.Datapoint = Datapoint;
        var Alarm = {};
        Controllers.Alarm = Alarm;
        var System = {};
        Controllers.System = System;
        var Favorite = {};
        Controllers.Favorite = Favorite;
        var Portal = {};
        Controllers.Portal = Portal;
        var Device = {};
        Controllers.Device = Device;
        var User = {};
        Controllers.User = User;
        var Security = {};
        Controllers.Security = Security;
        var Scene = {};
        Controllers.Scene = Scene;
        var Statistic = {};
        Controllers.Statistic = Statistic;
        var Logging = {};
        Controllers.Logging = Logging;


        //-----------------------------
        //   API METHODS
        //-----------------------------
        // Define available
        //
        // Every Method can have a Property. If this Property is set, the passed object is sent to api as value of this property
        // e.g. if Property is Favorite.
        // call is API.Favorite.AddOrUpdateFavorite( {FavoriteId : ...} )
        // ApiCall will be a JSON { Favorite: {FavoriteId:....} }
        // If PRoperty is empty, we use the regular Object
        // ApiCall will be a JSON { Property:Value1, Property2:Value2 .... };
        //
        Menu.Methods = [
            {Method: 'AddOrUpdateCustomMenuEntry'},
            {Method: 'GetBundlesByCategory'},
            {Method: 'GetBundlesByConfigs'},
            {Method: 'GetChildEntries'},
            {Method: 'GetCustomMenuEntries'},
            {Method: 'GetMenuEntriesByIds'},
            {Method: 'GetMenuEntriesByIdsAndDeviceType'},
            {Method: 'RemoveCustomMenuEntries'}
        ];
        var MenuRes = $resource(api_host, null, {
                'AddOrUpdateCustomMenuEntry': {url: api_host + 'Menu/AddOrUpdateCustomMenuEntry'},
                'GetBundlesByCategory': {url: api_host + 'Menu/GetBundlesByCategory/' + destinationId, method: 'POST', isArray: true},
                'GetBundlesByConfigs': {url: api_host + 'Menu/GetBundlesByConfigs/' + destinationId, method: 'POST', isArray: true},
                'GetChildEntries': {url: api_host + 'Menu/GetChildEntries/' + destinationId, method: 'POST'},
                'GetCustomMenuEntries': {
                    url: api_host + 'Menu/GetCustomMenuEntries/' + destinationId,
                    method: 'POST',
                    isArray: true
                },
                'GetMenuEntriesByIds': {url: api_host + 'Menu/GetMenuEntriesByIds/' + destinationId, method: 'POST'},
                'GetMenuEntriesByIdsAndDeviceType': {
                    url: api_host + 'Menu/GetMenuEntriesByIdsAndDeviceType/' + destinationId,
                    method: 'POST'
                },
                'RemoveCustomMenuEntries': {
                    url: api_host + 'Menu/RemoveCustomMenuEntries/' + destinationId,
                    method: 'POST'
                }
            }
        );

        Datapoint.Methods = [
            {Method: 'AddConfigsToLogPreset'},
            {Method: 'ClearCustomConfig'},
            {Method: 'GetConfigs'},
            {Method: 'GetConfigsByCategory'},
            {Method: 'GetConfigsByDatapointValues'},
            {Method: 'GetConfigsByDeviceId'},
            {Method: 'GetConfigsByDeviceType'},
            {Method: 'GetConfigsByFilter'},
            {Method: 'GetConfigsByLogPresets'},
            {Method: 'GetRelatedConfigs'},
            {Method: 'ReadValues'},
            {Method: 'SetCustomConfig'},
            {Method: 'WriteValues'}
        ];
        var DatapointRes = $resource(api_host, null, {
            "AddConfigsToLogPreset": {
                url: api_host + 'Datapoint/AddConfigsToLogPreset/' + destinationId,
                method: 'POST',
                isArray: false
            },
            "ClearCustomConfig": {
                url: api_host + 'Datapoint/ClearCustomConfig/' + destinationId,
                method: 'POST',
                isArray: false
            },
            "GetConfigs": {url: api_host + 'Datapoint/GetConfigs/' + destinationId, method: 'POST', isArray: true},
            "GetConfigsByCategory": {
                url: api_host + 'Datapoint/GetConfigsByCategory/' + destinationId,
                method: 'POST',
                isArray: true
            },
            "GetConfigsByDatapointValues": {
                url: api_host + 'Datapoint/GetConfigsByDatapointValues/' + destinationId,
                method: 'POST',
                isArray: true
            },
            "GetConfigsByDeviceId": {
                url: api_host + 'Datapoint/GetConfigsByDeviceId/' + destinationId,
                method: 'POST',
                isArray: true
            },
            "GetConfigsByDeviceType": {
                url: api_host + 'Datapoint/GetConfigsByDeviceType/' + destinationId,
                method: 'POST',
                isArray: false
            },
            "GetConfigsByFilter": {
                url: api_host + 'Datapoint/GetConfigsByFilter/' + destinationId,
                method: 'POST',
                isArray: false
            },
            "GetConfigsByLogPresets": {
                url: api_host + 'Datapoint/GetConfigsByLogPresets/' + destinationId,
                method: 'POST',
                isArray: false
            },
            "GetRelatedConfigs": {
                url: api_host + 'Datapoint/GetRelatedConfigs/' + destinationId,
                method: 'POST',
                isArray: false
            },
            "ReadValues": {url: api_host + 'Datapoint/ReadValues/' + destinationId, method: 'POST', isArray: true},
            "SetCustomConfig": {
                url: api_host + 'Datapoint/SetCustomConfig/' + destinationId,
                method: 'POST',
                isArray: false
            },
            "WriteValues": {
                url: api_host + 'Datapoint/WriteValues/' + destinationId,
                method: 'POST',
                isArray: false
            },
        });
        Favorite.Methods = [
            {Method: 'AddOrUpdateFavorite'},
            {Method: 'GetFavoriteById'},
            {Method: 'GetFavorites'},
            {Method: 'RemoveFavorite'}
        ];
        var FavoriteRes = $resource(api_host, null, {
            "AddOrUpdateFavorite": {
                url: api_host + 'Favorite/WriteValues/' + destinationId,
                method: 'POST',
                isArray: false
            },
            "GetFavoriteById": {
                url: api_host + 'Favorite/GetFavoriteById/' + destinationId,
                method: 'POST',
                isArray: false
            },
            "GetFavorites": {
                url: api_host + 'Favorite/GetFavorites/' + destinationId,
                method: 'POST',
                isArray: true
            },
            "RemoveFavorite": {
                url: api_host + 'Favorite/RemoveFavorite/' + destinationId,
                method: 'POST',
                isArray: false
            },
        });
        Alarm.Methods = [
            {Method: 'ClearAlarmHistory'},
            {Method: 'ClearCurrentAlarm'},
            {Method: 'ClearCurrentAlarms'},
            {Method: 'GetAlarmHistory'},
            {Method: 'GetCurrentAlarms'}
        ];
        var AlarmRes = $resource(api_host, null, {
            "ClearAlarmHistory": {
                url: api_host + 'Alarm/ClearAlarmHistory/' + destinationId,
                method: 'POST',
                isArray: false
            },
            "ClearCurrentAlarm": {
                url: api_host + 'Alarm/ClearCurrentAlarm/' + destinationId,
                method: 'POST',
                isArray: false
            },
            "ClearCurrentAlarms": {
                url: api_host + 'Alarm/ClearCurrentAlarms/' + destinationId,
                method: 'POST',
                isArray: false
            },
            "GetAlarmHistory": {
                url: api_host + 'Alarm/GetAlarmHistory/' + destinationId,
                method: 'POST',
                isArray: true
            },
            "GetCurrentAlarms": {
                url: api_host + 'Alarm/GetCurrentAlarms/' + destinationId,
                method: 'POST',
                isArray: true
            },
        });
        System.Methods = [
            {Method: 'DownloadBackup'},
            {Method: 'DownloadSysLog'},
            {Method: 'ExecuteCommand'},
            {Method: 'GetControlLogicSettings'},
            {Method: 'GetControlLogicStates'},
            {Method: 'GetHomeServerById'},
            {Method: 'GetHomeServers'},
            {Method: 'GetProtocolProviderSettings'},
            {Method: 'AddOrUpdateProtocolProviderSetting'},
            {Method: 'RemoveProtocolProviderSetting'},
            {Method: 'RemoveProtocolProviderSettingById'},
            {Method: 'GetSysLog'},
            {Method: 'GetFrontendSettings' },
            {Method: 'ReadSetting'},
            {Method: 'ResolveEnum'},
            {Method: 'ResolveEnums'},
            {Method: 'UpdateControlLogicSettings'},
            {Method: 'UploadBackup'},
            {Method: 'WriteFile'},
            {Method: 'WriteSettings'}

        ];
        var SystemRes = $resource(api_host, null, {
            "DownloadBackup": {
                url: api_host + 'System/DownloadBackup/' + destinationId,
                method: 'POST',
                isArray: false
            },
            "DownloadSysLog": {
                url: api_host + 'System/DownloadSysLog/' + destinationId,
                method: 'POST',
                isArray: false
            },
            "ExecuteCommand": {
                url: api_host + 'System/ExecuteCommand/' + destinationId,
                method: 'POST',
                isArray: true
            },
            "GetControlLogicSettings": {
                url: api_host + 'System/GetControlLogicSettings/' + destinationId,
                method: 'GET',
                isArray: true
            },
            "GetControlLogicStates": {
                url: api_host + 'System/GetControlLogicStates/' + destinationId,
                method: 'GET',
                isArray: true
            },
            "GetHomeServerById": {
                url: api_host + 'System/GetHomeServerById/' + destinationId,
                method: 'POST',
                isArray: false
            },
            "GetHomeServers": {
                url: api_host + 'System/GetHomeServers/' + destinationId,
                method: 'POST',
                isArray: false
            },
            "GetProtocolProviderSettings": {
                url: api_host + 'System/GetProtocolProviderSettings/' + destinationId,
                method: 'POST',
                isArray: true
            },
            "AddOrUpdateProtocolProviderSetting": {
                url: api_host + 'System/AddOrUpdateProtocolProviderSetting/' + destinationId,
                method: 'POST',
                isArray: false
            },
            "RemoveProtocolProviderSetting": {
                url: api_host + 'System/RemoveProtocolProviderSetting/' + destinationId,
                method: 'POST',
                isArray: false
            },
            "RemoveProtocolProviderSettingById": {
                url: api_host + 'System/RemoveProtocolProviderSettingById/' + destinationId,
                method: 'POST',
                isArray: false
            },
            "GetFrontendSettings": {
                url: api_host + 'System/GetFrontendSettings/' + destinationId,
                method: 'GET',
                isArray: false
            },
            "GetSysLog": {url: api_host + 'System/GetSysLog/' + destinationId, method: 'POST', isArray: false},
            "ReadSetting": {url: api_host + 'System/ReadSetting/' + destinationId, method: 'POST', isArray: false},
            "ResolveEnum": {url: api_host + 'System/ResolveEnum/' + destinationId, method: 'POST', isArray: false},
            "ResolveEnums": {url: api_host + 'System/ResolveEnums/' + destinationId, method: 'POST', isArray: true,
                transformResponse: function(data)
                {
                    var response = {};
                    if (isJson(data))
                    {
                        data = angular.fromJson(data);
                        response = data.ResponseData;
                    }

                    response.forEach((rd) => {
                        for (const key in rd.Metadata) {
                            if (Object.hasOwnProperty.call(rd.Metadata, key)) {
                                const mtd = rd.Metadata[key];
                                mtd.EnumValueKeyNumber = +key;
                            }
                        }
                    });
                    return response;
                }
            },
            "UpdateControlLogicSettings": {
                url: api_host + 'System/UpdateControlLogicSettings/' + destinationId,
                method: 'POST',
                isArray: false
            },
            "UploadBackup": {
                url: api_host + 'System/UploadBackup/' + destinationId,
                method: 'POST',
                isArray: false
            },
            "WriteFile": {
                url: api_host + 'System/WriteFile/' + destinationId,
                method: 'POST',
                isArray: false
            },
            "WriteSettings": {
                url: api_host + 'System/WriteSettings/' + destinationId,
                method: 'POST',
                isArray: false
            },

        });
        function isJson(str)
        {
            try
            {
                JSON.parse(str);
            }
            catch (e)
            {
                return false;
            }
            return true;
        }
        Portal.Methods = [
            {Method: 'GetAccessPrincipals'},
            {Method: 'PortalController'},
            {Method: 'SetAccessPrincipal'}
        ];
        var PortalRes = $resource(api_host, null, {
            "GetAccessPrincipals": {
                url: api_host + 'Portal/GetAccessPrincipals/' + destinationId,
                method: 'GET',
                isArray: true
            },
            "PortalController": {
                url: api_host + 'Portal/PortalController/' + destinationId,
                method: 'POST',
                isArray: false
            },
            "SetAccessPrincipal": {
                url: api_host + 'Portal/SetAccessPrincipal/' + destinationId,
                method: 'POST',
                isArray: false
            }
        });
        Device.Methods = [
            {Method: 'AddDevice'},
            {Method: 'AddOrUpdateLogSettings'},
            {Method: 'GetAllDevices'},
            {Method: 'GetAllLogSettings'},
            {Method: 'GetChildDevices'},
            {Method: 'GetDevice'},
            {Method: 'GetDevicesByFilter'},
            {Method: 'GetDevicesByMenuEntry'},
            {Method: 'GetDevicesByType'},
            {Method: 'GetLearnModeState'},
            {Method: 'GetLogSetting'},
            {Method: 'RefreshDevice'},
            {Method: 'RemoveDevice'},
            {Method: 'RemoveLogSetting'},
            {Method: 'SetLearnModeEnabled'},
            {Method: 'UpdateDevice'}
        ];
        var DeviceRes = $resource(api_host, null, {
            "AddDevice": {url: api_host + 'Device/AddDevice/' + destinationId, method: 'POST', isArray: false},
            "AddOrUpdateLogSettings": {
                url: api_host + 'Device/AddOrUpdateLogSettings/' + destinationId,
                method: 'POST',
                isArray: false
            },
            "GetAllDevices": {
                url: api_host + 'Device/GetAllDevices/' + destinationId,
                method: 'GET',
                isArray: true
            },
            "GetAllLogSettings": {
                url: api_host + 'Device/GetAllLogSettings/' + destinationId,
                method: 'GET',
                isArray: true
            },
            "GetChildDevices": {
                url: api_host + 'Device/GetChildDevices/' + destinationId,
                method: 'POST',
                isArray: false
            },
            "GetDevice": {url: api_host + 'Device/GetDevice/' + destinationId, method: 'POST', isArray: false},
            "GetDevicesByFilter": {
                url: api_host + 'Device/GetDevicesByFilter/' + destinationId,
                method: 'POST',
                isArray: true
            },
            "GetDevicesByMenuEntry": {
                url: api_host + 'Device/GetDevicesByMenuEntry/' + destinationId,
                method: 'POST',
                isArray: true
            },
            "GetDevicesByType": {
                url: api_host + 'Device/GetDevicesByType/' + destinationId,
                method: 'POST',
                isArray: true
            },
            "GetLearnModeState": {
                url: api_host + 'Device/GetLearnModeState/' + destinationId,
                method: 'POST',
                isArray: false
            },
            "GetLogSetting": {
                url: api_host + 'Device/GetLogSetting/' + destinationId,
                method: 'POST',
                isArray: false
            },
            "RefreshDevice": {
                url: api_host + 'Device/RefreshDevice/' + destinationId,
                method: 'POST',
                isArray: false
            },
            "RemoveDevice": {
                url: api_host + 'Device/RemoveDevice/' + destinationId,
                method: 'POST',
                isArray: false
            },
            "RemoveLogSetting": {
                url: api_host + 'Device/RemoveLogSetting/' + destinationId,
                method: 'POST',
                isArray: false
            },
            "SetLearnModeEnabled": {
                url: api_host + 'Device/SetLearnModeEnabled/' + destinationId,
                method: 'POST',
                isArray: false
            },
            "UpdateDevice": {url: api_host + 'Device/UpdateDevice/' + destinationId, method: 'POST', isArray: false}
        });
        User.Methods = [
            {Method: 'AddOrUpdateLocalUser'},
            {Method: 'ChangeLanguage'},
            {Method: 'GetCurrentUser'},
            {Method: 'GetLanguage'},
            {Method: 'GetLocalUsers'},
            {Method: 'GetNotification'},
            {Method: 'GetUserLevel'},
            {Method: 'SetNotification'},
            {Method: 'UserLevelLogin'},
            {Method: 'UserLevelLogout'},
            {Method: 'Validate'}

        ];
        var UserRes = $resource(api_host, null, {
            "AddOrUpdateLocalUser": {
                url: api_host + 'User/AddOrUpdateLocalUser/' + destinationId,
                method: 'POST',
                isArray: false
            },
            "ChangeLanguage": {
                url: api_host + 'User/ChangeLanguage/' + destinationId,
                method: 'POST',
                isArray: false
            },
            "GetCurrentUser": {
                url: api_host + 'User/GetCurrentUser/' + destinationId,
                method: 'GET',
                isArray: false
            },
            "GetLanguage": {url: api_host + 'User/GetLanguage/' + destinationId, method: 'GET', isArray: false, transformResponse : function ( data ) { return {lang: angular.fromJson( data ) } } },
            "GetLocalUsers": {
                url: api_host + 'User/GetLocalUsers/' + destinationId,
                method: 'GET',
                isArray: true
            },
            "GetNotification": {
                url: api_host + 'User/GetNotification/' + destinationId,
                method: 'POST',
                isArray: true
            },
            "GetUserLevel": {url: api_host + 'User/GetUserLevel/' + destinationId, method: 'GET', isArray: false, transformResponse: function (data) { return data ? {userlevel: angular.fromJson(data).ResponseData}: {userlevel:0}}},
            "SetNotification": {
                url: api_host + 'User/SetNotification/' + destinationId,
                method: 'POST',
                isArray: false
            },
            "UserLevelLogin": {
                url: api_host + 'User/UserLevelLogin/' + destinationId,
                method: 'POST',
                isArray: false,
                transformResponse : function ( data ) { return {userlevel: angular.fromJson( data ).ResponseData } }
            },
            "UserLevelLogout": {
                url: api_host + 'User/UserLevelLogout/' + destinationId,
                method: 'GET',
                isArray: false
            },
            "Validate": {url: api_host + 'User/Validate/' + destinationId, method: 'POST', isArray: false},
        });
        Security.Methods = [
            {Method: 'Login'},
            {Method: 'Register'},
            {Method: 'Logout'}
        ];
        var SecurityRes = $resource(api_host, null, {
            "Login": {url: api_host + 'Security/Login/' + destinationId, method: 'POST', isArray: false},
            "Register": {url: api_host + 'Security/Register/' + destinationId, method: 'POST', isArray: false},
            "Logout": {url: api_host + 'Security/Logout', method: 'POST', isArray: false}
        });
        Scene.Methods = [
            {Method:'AddOrUpdateScene'},
            {Method: 'ExecuteScene'},
            {Method: 'GetAllScenes'},
            {Method: 'GetScenesOverview'},
            {Method: 'GetSceneActionDatapoints'},
            {Method: 'GetSceneById'},
            {Method: 'GetSceneIdsByDeviceId'},
            {Method: 'GetSceneIdsByMenuEntryId'},
            {Method: 'GetSceneIdsByDatapointValue'},
            {Method: 'RemoveScene'},
            {Method: 'ResetScene'},
            {Method: 'UpdateSceneSettings'},
            {Method: 'SceneController'},
            {Method: 'GetDeviceIdsBySceneId'},
            {Method: 'GetScenesByDeviceId'}
        ];
        var SceneRes = $resource(api_host, null, {
            "AddOrUpdateScene" : {url: api_host + 'Scene/AddOrUpdateScene/' + destinationId, method: 'POST', isArray: false,  transformResponse: function (data) {
                //console.log('Data from Call',angular.fromJson(data));
                var r = angular.fromJson(data);
                if(r.StatusCode == 0)
                {
                    return { string: r.ResponseData }
                }else{
                    return r;
                }

            }
            },
            "ExecuteScene": {url: api_host + 'Scene/ExecuteScene/' + destinationId, method: 'POST', isArray: false},
            "GetAllScenes": {url: api_host + 'Scene/GetAllScenes/' + destinationId, method: 'GET', isArray: true, cancellable: true},
            "GetScenesOverview": {url: api_host + 'Scene/GetScenesOverview/' + destinationId, method: 'GET', isArray: true, cancellable: true},
            "GetSceneActionDatapoints": {
                url: api_host + 'Scene/GetSceneActionDatapoints/' + destinationId,
                method: 'POST',
                isArray: true
            },
            "GetSceneById": {url: api_host + 'Scene/GetSceneById/' + destinationId, method: 'POST', isArray: false},
            "GetSceneIdsByDeviceId": {
                url: api_host + 'Scene/GetSceneIdsByDeviceId/' + destinationId,
                method: 'POST',
                isArray: false
            },
            "GetSceneIdsByMenuEntryId": {
                url: api_host + 'Scene/GetSceneIdsByMenuEntryId/' + destinationId,
                method: 'POST',
                isArray: false
            },
            "GetSceneIdsByDatapointValue": {
                url: api_host + 'Scene/GetSceneIdsByDatapointValue/' + destinationId,
                method: 'POST',
                isArray: false
            },
            "RemoveScene": {url: api_host + 'Scene/RemoveScene/' + destinationId, method: 'POST', isArray: false},
            "ResetScene": {url: api_host + 'Scene/ResetScene/' + destinationId, method: 'POST', isArray: false},
            "UpdateSceneSettings": {url: api_host + 'Scene/UpdateSceneSettings/' + destinationId, method: 'POST', isArray: true},
            "SceneController": {
                url: api_host + 'Scene/SceneController/' + destinationId,
                method: 'POST',
                isArray: false
            },
            "GetDeviceIdsBySceneId": {
                url: api_host + 'Scene/GetDeviceIdsBySceneId/' + destinationId,
                method: 'POST',
                isArray: true
            },
            "GetScenesByDeviceId": {
                url: api_host + 'Scene/GetScenesByDeviceId/' + destinationId,
                method: 'POST',
                isArray: true
            }
        });
        Statistic.Methods = [
            {Method: 'AddToStatistic'},
            {Method: 'GetAvailableStatisticData'},
            {Method: 'GetStatistic'},
            {Method: 'StatisticController'}
        ];
        var StatisticRes = $resource(api_host, null, {
            "AddToStatistic": {
                url: api_host + 'Statistic/AddToStatistic/' + destinationId,
                method: 'POST',
                isArray: false
            },
            "GetAvailableStatisticData": {
                url: api_host + 'Statistic/GetAvailableStatisticData/' + destinationId,
                method: 'POST',
                isArray: false
            },
            "GetStatistic": {
                url: api_host + 'Statistic/GetStatistic/' + destinationId,
                method: 'POST',
                isArray: true
            },
            "StatisticController": {
                url: api_host + 'Statistic/StatisticController/' + destinationId,
                method: 'POST',
                isArray: false
            },
        });
        Logging.Methods = [
            {Method: 'AddOrUpdateLogPreset'},
            {Method: 'AddToDatapointLog'},
            {Method: 'ApplyLogPreset'},
            {Method: 'DeleteLogPreset'},
            {Method: 'GetAllLogPresets'},
            {Method: 'GetAvailableLogData'},
            {Method: 'GetDatapointLogs'},
            {Method: 'GetLogPresetsByType'},
            {Method: 'LoggingController'}
        ];
        var LoggingRes = $resource(api_host, null, {
            "AddOrUpdateLogPreset": {
                url: api_host + 'Logging/AddOrUpdateLogPreset/' + destinationId,
                method: 'POST',
                isArray: false
            },
            "AddToDatapointLog": {
                url: api_host + 'Logging/AddToDatapointLog/' + destinationId,
                method: 'POST',
                isArray: false
            },
            "ApplyLogPreset": {
                url: api_host + 'Logging/ApplyLogPreset/' + destinationId,
                method: 'POST',
                isArray: true
            },
            "DeleteLogPreset": {
                url: api_host + 'Logging/DeleteLogPreset/' + destinationId,
                method: 'POST',
                isArray: false
            },
            "GetAllLogPresets": {
                url: api_host + 'Logging/GetAllLogPresets/' + destinationId,
                method: 'POST',
                isArray: false
            },
            "GetAvailableLogData": {
                url: api_host + 'Logging/GetAvailableLogData/' + destinationId,
                method: 'POST',
                isArray: true
            },
            "GetDatapointLogs": {
                url: api_host + 'Logging/GetDatapointLogs/' + destinationId,
                method: 'POST',
                isArray: true
            },
            "GetLogPresetsByType": {
                url: api_host + 'Logging/GetLogPresetsByType/' + destinationId,
                method: 'POST',
                isArray: false
            },
            "LoggingController": {
                url: api_host + 'Logging/LoggingController/' + destinationId,
                method: 'POST',
                isArray: false
            }
        });


        Menu.APIRes = MenuRes;
        Datapoint.APIRes = DatapointRes;
        Alarm.APIRes = AlarmRes;
        System.APIRes = SystemRes;
        Favorite.APIRes = FavoriteRes;
        Portal.APIRes = PortalRes;
        Device.APIRes = DeviceRes;
        User.APIRes = UserRes;
        Security.APIRes = SecurityRes;
        Scene.APIRes = SceneRes;
        Statistic.APIRes = StatisticRes;
        Logging.APIRes = LoggingRes;
        // Generate Methods of each Controller
        for (var key in Controllers) {
            if (Controllers.hasOwnProperty(key)) {
                obj[key] = {};
                obj[key].APIRes = Controllers[key].APIRes;
                if (Controllers[key].Methods == undefined) {
                    continue;
                }
                var fn;
                for (var i = 0; i < Controllers[key].Methods.length; i++) {
                    if (Controllers[key].Methods[i].Property != undefined) {
                        fn = 'var b = {};b["' + Controllers[key].Methods[i].Property + '"] = a; return this.APIRes.' + Controllers[key].Methods[i].Method + '(b);'
                    } else {
                        fn = 'return this.APIRes.' + Controllers[key].Methods[i].Method + '(a);'
                    }
                    obj[key][Controllers[key].Methods[i].Method] = new Function('a', fn);
                }
            }
        }
        //console.log(obj);


        return function () {
            return obj;
        };

    }]);
